<div class="fullpage narrative">
    <div *ngIf="shared.play" style="padding-bottom: 50px;">
        <ng-container *ngFor="let story of shared.play.story">
            <div *ngIf="story.published" app-read-story [story]="story"></div>
        </ng-container>
    </div>
</div>
